module.exports = __webpack_public_path__ + "img/p-2.d51aad21.png";